import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.checkliste-aufgabe-bild-scaled';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenChecklisteAufgabeBildScaledEffects {

    ChecklisteAufgabeBildScaled$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_CHECKLISTE_AUFGABE_BILD_SCALED),
        mergeMap((x: ac.GetChecklisteAufgabeBildScaledAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getChecklisteAufgabeBildScaled(x.checkliste_id, x.aufgabe_id, x.bild_id, x.width, x.height).pipe(
                map((result: any) => {
                    return new ac.GetChecklisteAufgabeBildScaledErfolgreichAction(result, x.checkliste_id, x.aufgabe_id, x.bild_id, x.width, x.height, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetChecklisteAufgabeBildScaledFehlerAction(error, x.checkliste_id, x.aufgabe_id, x.bild_id, x.width, x.height, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ChecklisteQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ChecklisteQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ChecklisteQueryService);
        }
        return this.service;
    }
}
